/*
 * Copyright ish group pty ltd. All rights reserved. https://www.ish.com.au
 * No copying or use of this code is allowed without permission in writing from ish.
 */

import { Properties } from '@api/model';
import { Epic } from 'redux-observable';
import GoogleService from '../../../api/services/GoogleService';
import { GET_PUBLIC_PROPERTIES, getPublicPropertiesFulfilled } from '../../actions/SystemProperties';
import { Create, Request } from '../EpicUtils';

const request: Request<Properties, null> = {
  type: GET_PUBLIC_PROPERTIES,
  getData: () => GoogleService.getPublicProperties(),
  processData: (res) => [getPublicPropertiesFulfilled(res)]
};

export const EpicGetPublicProperties: Epic<any, any> = Create(request);